export default __webpack_public_path__ + "static/media/(67).34974003.jpg";